import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const MASCOT = "https://customer-assets-jt897jd0.emergentagent.net/job_smoke-beach-drop/artifacts/g2ejgl6q_maskotka-obrys.webp";

export const Preloader = ({ onDone }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const start = performance.now();
    const dur = 2600;
    let raf;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / dur);
      setProgress(Math.floor(p * 100));
      if (p < 1) raf = requestAnimationFrame(tick);
      else setTimeout(onDone, 450);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0a0a0a]"
      exit={{ y: "-100%", transition: { duration: 0.85, ease: [0.76, 0, 0.24, 1] } }}
    >
      <div className="absolute inset-0 halftone-light" />
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="smoke-puff absolute left-1/2 top-1/2 h-64 w-64 -translate-x-1/2 rounded-full bg-[#d96b43]/25 blur-3xl" />
        <div className="smoke-puff absolute left-1/3 top-2/3 h-48 w-48 rounded-full bg-[#e5b83b]/15 blur-3xl" style={{ animationDelay: "1.2s" }} />
      </div>

      <motion.img
        src={MASCOT}
        alt="$IGN UP! mascot"
        data-testid="preloader-mascot"
        className="mascot-glow relative z-10 w-56 sm:w-72"
        initial={{ scale: 1, opacity: 1, rotate: 0 }}
        animate={{ scale: [1, 1.04, 1] }}
        transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
      />

      <span className="mask-line relative z-10 mt-2">
        <motion.span
          className="toon-text block font-script text-4xl text-[#f4f1ea] sm:text-6xl"
          initial={{ y: "112%" }}
          animate={{ y: 0 }}
          transition={{ delay: 0.4, duration: 0.7, ease: [0.34, 1.56, 0.64, 1] }}
        >
          smoke hash stack cash
        </motion.span>
      </span>

      <div className="relative z-10 mt-10 w-60 sm:w-80">
        <div className="h-3 w-full rounded-full border-[3px] border-[#0a0a0a] bg-[#1a1a1e] shadow-[4px_4px_0_#000]">
          <div className="h-full rounded-full bg-[#d96b43] transition-[width] duration-100" style={{ width: `${progress}%` }} />
        </div>
        <div className="mt-3 flex items-center justify-between font-mono2 text-[11px] tracking-[0.3em] text-[#9a9890]">
          <span>DROP 003</span>
          <span data-testid="preloader-progress" className="text-[#e5b83b]">{String(progress).padStart(3, "0")}%</span>
        </div>
      </div>
    </motion.div>
  );
};
